import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from '@environments';

export function translateLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, `${environment.deployURL}assets/i18n/`, '.json');
}
